import { ActionType, getType } from 'typesafe-actions';
import * as actions from './bulkUpload.action';
import { BulkOperationStatus, BulkOperationStatusResponse } from 'services/lms/lmsBulkUpload.service';

export interface BulkUploadState {
	upload: {
		isLoading: boolean;
		bulkOperationId: string | null;
		error: string | null;
	};
	status: {
		isLoading: boolean;
		data: BulkOperationStatus | undefined;
		error: string | null;
	};
	template: {
		isLoading: boolean;
		downloadUrl: string | null;
		error: string | null;
	};
}

const initialState: BulkUploadState = {
	upload: {
		isLoading: false,
		bulkOperationId: null,
		error: null,
	},
	status: {
		isLoading: false,
		data: undefined,
		error: null,
	},
	template: {
		isLoading: false,
		downloadUrl: null,
		error: null,
	},
};

type BulkUploadAction = ActionType<typeof actions>;

export function bulkUploadReducer(state = initialState, action: BulkUploadAction): BulkUploadState {
	switch (action.type) {
		// Upload actions
		case getType(actions.uploadLMSFile.request):
			return {
				...state,
				upload: {
					...state.upload,
					isLoading: true,
					error: null,
				},
				status: {
					...state.status,
					data: undefined,
				},
			};
		case getType(actions.uploadLMSFile.success):
			return {
				...state,
				upload: {
					...state.upload,
					isLoading: false,
					bulkOperationId: action.payload.data,
					error: null,
				},
			};
		case getType(actions.uploadLMSFile.failure):
			return {
				...state,
				upload: {
					...state.upload,
					isLoading: false,
					error: action.payload,
				},
			};

		// Status actions
		case getType(actions.getBulkOperationStatus.request):
			return {
				...state,
				status: {
					...state.status,
					isLoading: true,
					error: null,
				},
			};
		case getType(actions.getBulkOperationStatus.success):
			return {
				...state,
				status: {
					...state.status,
					isLoading: false,
					data: action.payload.data,
					error: null,
				},
			};
		case getType(actions.getBulkOperationStatus.failure):
			return {
				...state,
				status: {
					...state.status,
					isLoading: false,
					error: action.payload,
				},
			};

		// Template actions
		case getType(actions.downloadLMSTemplate.request):
			return {
				...state,
				template: {
					...state.template,
					isLoading: true,
					error: null,
				},
			};
		case getType(actions.downloadLMSTemplate.success):
			return {
				...state,
				template: {
					...state.template,
					isLoading: false,
					downloadUrl: action.payload.data,
					error: null,
				},
			};
		case getType(actions.downloadLMSTemplate.failure):
			return {
				...state,
				template: {
					...state.template,
					isLoading: false,
					error: action.payload,
				},
			};

		// Reset actions
		case 'RESET_BULK_UPLOAD_STATE':
			return initialState;
		case 'CLEAR_BULK_OPERATION_STATUS':
			return {
				...state,
				status: {
					...state.status,
					data: undefined,
					error: null,
				},
			};

		default:
			return state;
	}
}
